import { MenuCategory } from "./menu.category.model";
import { CategoryScheduleBuilder } from "./menu.category.schedule.builder";

export class MenuCategoryBuilder {
  private _id: string;
  private _name: string;
  private _position: number;
  private _isActive: boolean;
  private _color: string;
  private _schedule: CategoryScheduleBuilder;
  private _image: string;

  constructor() {
    this.default();
  }

  public get id(): string {
    return this._id || "";
  }

  public set id(id: string) {
    this._id = id;
  }

  public get isActive(): boolean {
    return this._isActive;
  }
  public set isActive(b: boolean) {
    this._isActive = b;
  }

  public get image(): string {
    return this._image;
  }
  public set image(image: string) {
    this._image = image;
  }

  public get name(): string {
    return this._name;
  }

  public get position(): number {
    return this._position;
  }

  public get color(): string {
    return this._color;
  }

  public get schedule(): CategoryScheduleBuilder {
    return this._schedule;
  }
  public set name(name: string) {
    this._name = name;
  }

  public set position(position: number) {
    this._position = position;
  }

  public set color(color: string) {
    this._color = color;
  }

  public toAPIResponse = () => ({
    id: this.id,
    name: this.name,
    position: this.position,
    color: this.color,
    isActive: this.isActive,
    schedule: this._schedule.toJSON(),
    image: null
  });

  public build(): MenuCategory {
    return new MenuCategory(this);
  }

  public edit(category: MenuCategory): MenuCategoryBuilder {
    this._name = category.name;
    this._isActive = category.isActive;
    this._schedule = new CategoryScheduleBuilder().edit(category.schedule);
    this._color = category.color;
    this._position = category.position;
    this._image = category.image;
    this._id = category.id;
    return this;
  }

  public loadAPIResponse(data: any): MenuCategoryBuilder {
    this._name = data.name;
    this._isActive = data.isActive;
    this._color = data.color;
    this._schedule = new CategoryScheduleBuilder().load(data.schedule);
    this._position = data.position;
    this._id = data.id;

    return this;
  }

  private default() {
    this._isActive = true;
    this._color = "Blue";
    this._name = "";
    this._image = null;
    this._position = 99;
    this._schedule = new CategoryScheduleBuilder();
    this._id = "";
  }
}
